import {createReducer} from "@reduxjs/toolkit";
import {createAction} from "redux-actions";

export const setRegistrationState = createAction("CABLE_SET_REGISTRATION_STATE");
export const setIsDeclining = createAction("CABLE_SET_IS_DECLINING");
export const setShowForm = createAction("CABLE_SET_SHOW_FORM");
export const setIsSending = createAction("CABLE_SET_IS_SENDING");
export const setTagOwner = createAction("SET_TAG_OWNER");
export const setThankYouText = createAction("SET_THANK_YOU_TEXT");
export const setPrintPdf = createAction("SET_PRINT_PDF")

const reducer = createReducer({}, {
  [setRegistrationState]: (state, action) => {
    state.registrationPageState = {
      ...state.registrationPageState,
      state: action.payload
    }
  },
  [setIsDeclining]: (state, action) => {
    state.registrationPageState = {
      ...state.registrationPageState,
      isDeclining: action.payload
    }
  },
  [setTagOwner]: (state, action) => {
    state.tagOwner = action.payload
  },
  [setThankYouText]: (state, action) => {
    state.thankYouText = action.payload
  },
  [setShowForm]: (state, action) => {
    state.registrationPageState = {
      ...state.registrationPageState,
      showForm: action.payload
    }
  },
  [setIsSending]: (state, action) => {
    state.registrationPageState = {
      ...state.registrationPageState,
      isSending: action.payload
    }
  },
  [setPrintPdf]: (state, action) => {
    state.printTimestamp = new Date().toISOString();
  },
});

export default reducer;
